export const adminLanguageOptions: { label: string, value: string }[] = [
    { value: 'da-DK', label: 'Danish (Denmark)' },
    { value: 'de-DE', label: 'Deutsch (Germany)' },
    { value: 'en-US', label: 'English (United States)' },
    { value: 'es-ES', label: 'Spanish (Spain)' },
    { value: 'fi-FI', label: 'Finnish (Finland)' },
    { value: 'fr-FR', label: 'French (France)' },
    { value: 'it-IT', label: 'Italian (Italy)' },
    { value: 'ja-JP', label: 'Japanese (Japan)' },
    { value: 'nl-NL', label: 'Dutch (Netherlands)' },
    { value: 'no-NO', label: 'Norwegian (Norway)' },
    { value: 'pl-PL', label: 'Polish (Poland)' },
    { value: 'pt-BR', label: 'Portuguese (Brazil)' },
    { value: 'sv-SE', label: 'Swedish (Sweden)' },
    { value: 'tr-TR', label: 'Turkish (Turkey)' },
    { value: 'zh-CN', label: 'Chinese (Simplified, China)' },
    // { value: 'de-AT', label: 'Deutsch (Austria)' },
    // { value: 'de-CH', label: 'Deutsch (Switzerland)' },
    // { value: 'en-AU', label: 'English (Australia)' },
    // { value: 'en-CA', label: 'English (Canada)' },
    // { value: 'en-GB', label: 'English (United Kingdom)' },
    // { value: 'en-IE', label: 'English (Ireland)' },
    // { value: 'en-IN', label: 'English (India)' },
    // { value: 'en-NZ', label: 'English (New Zealand)' },
    // { value: 'en-ZA', label: 'English (South Africa)' },
    // { value: 'es-AR', label: 'Spanish (Argentina)' },
    // { value: 'es-CL', label: 'Spanish (Chile)' },
    // { value: 'es-CO', label: 'Spanish (Colombia)' },
    // { value: 'es-MX', label: 'Spanish (Mexico)' },
    // { value: 'es-US', label: 'Spanish (United States)' },
    // { value: 'fr-BE', label: 'French (Belgium)' },
    // { value: 'fr-CA', label: 'French (Canada)' },
    // { value: 'fr-CH', label: 'French (Switzerland)' },
    // { value: 'it-CH', label: 'Italian (Switzerland)' },
    // { value: 'pt-PT', label: 'Portuguese (Portugal)' },
    // { value: 'zh-HK', label: 'Chinese (Traditional, Hong Kong)' },
    // { value: 'zh-TW', label: 'Chinese (Traditional, Taiwan)' }
]

export const experienceLanguageOptions: { label: string, value: string }[] = [
    { value: 'da', label: 'Danish (Denmark)' },
    { value: 'de', label: 'Deutsch (Germany)' },
    { value: 'en', label: 'English (United States)' },
    { value: 'es', label: 'Spanish (Spain)' },
    { value: 'fi', label: 'Finnish (Finland)' },
    { value: 'fr', label: 'French (France)' },
    { value: 'it', label: 'Italian (Italy)' },
    { value: 'ja', label: 'Japanese (Japan)' },
    { value: 'nl', label: 'Dutch (Netherlands)' },
    { value: 'no', label: 'Norwegian (Norway)' },
    { value: 'pl', label: 'Polish (Poland)' },
    { value: 'pt', label: 'Portuguese (Brazil)' },
    { value: 'sv', label: 'Swedish (Sweden)' },
    { value: 'tr', label: 'Turkish (Turkey)' },
    { value: 'zh-CN', label: 'Chinese (Simplified, China)' },
    // { value: 'de-AT', label: 'Deutsch (Austria)' },
    // { value: 'de-CH', label: 'Deutsch (Switzerland)' },
    // { value: 'en-AU', label: 'English (Australia)' },
    // { value: 'en-CA', label: 'English (Canada)' },
    // { value: 'en-GB', label: 'English (United Kingdom)' },
    // { value: 'en-IE', label: 'English (Ireland)' },
    // { value: 'en-IN', label: 'English (India)' },
    // { value: 'en-NZ', label: 'English (New Zealand)' },
    // { value: 'en-ZA', label: 'English (South Africa)' },
    // { value: 'es-AR', label: 'Spanish (Argentina)' },
    // { value: 'es-CL', label: 'Spanish (Chile)' },
    // { value: 'es-CO', label: 'Spanish (Colombia)' },
    // { value: 'es-MX', label: 'Spanish (Mexico)' },
    // { value: 'es-US', label: 'Spanish (United States)' },
    // { value: 'fr-BE', label: 'French (Belgium)' },
    // { value: 'fr-CA', label: 'French (Canada)' },
    // { value: 'fr-CH', label: 'French (Switzerland)' },
    // { value: 'it-CH', label: 'Italian (Switzerland)' },
    // { value: 'pt-PT', label: 'Portuguese (Portugal)' },
    // { value: 'zh-HK', label: 'Chinese (Traditional, Hong Kong)' },
    // { value: 'zh-TW', label: 'Chinese (Traditional, Taiwan)' }
]
